import React, { Component } from 'react';
import AuthNavbar from '../navigation/authnavigation.jsx'
import LeftLink from '../leftlink/leftlink.jsx'

class UpgradeMyCard extends Component {
    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-sm-12">
                        <AuthNavbar />
                    </div>

                </div>
                <div className="container" style={{ marginTop: "80px" }}>
                    <div className="row">
                        <div className="col-sm-3 box-shadow-style nopadding">
                            <LeftLink />
                        </div>
                        <div className="col-sm-9" style={{ padding: "0px 30px" }}>
                            <div className="row box-shadow-style" style={{ padding: "12px 15px", minHeight: "476px" }} >
                                <div className="header" >
                                    <h2>Upgrade Card.</h2>
                                    <div>
                                        <p>Please note not all programs have an upgrade option. If you are unsure whether you are entitled to this service send us an email by clicking here <a>CONTACT US</a></p>
                                        <p>On confirmation you are entitled to a card upgrade you will be requested to confirm your identity by scanning a copy of your Driver’s Licence, Passport or Medicare Card and submitting it to us.</p>
                                        <p>We will confirm via email within 3 business days if your card upgrade has been successful. We will notify you of the higher load and spend limits and debit the Card Upgrade fee of $3.95 from your available balance.
                                </p>
                                        <p>If you are unsure if your card has been upgraded, you can check your program name on the Card Summary Page. If you see KYC next to your program name your card is upgraded.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default UpgradeMyCard;


// WEBPACK FOOTER //
// ./src/components/upgrademygrade/upgrademycard.jsx